import { IScope } from 'angular';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';
import { AutoScout24APIConfig } from '../../../src/app/@shared-types/api/autoscout24';

/* @ngInject */
export default class AutoScout24APIController {
  private $scope: IScope;

  public autoScout24Config: AutoScout24APIConfig | null = null;

  private settingsApiService: SettingsAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  constructor(
    $scope: IScope,
    settingsApiService: SettingsAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
  ) {
    this.settingsApiService = settingsApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;

    // load API configurations. If request fails, the tenant is not allowed to use this API.
    this.getConfig();
  }

  private getConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<AutoScout24APIConfig[]>(EExternalAPI.AUTOSCOUT24).catch();

    [this.autoScout24Config] = configs;
    this.interfaceService.applyScope(this.$scope);
  };

  public updateConfig = (
    apiId: string,
    config: unknown,
  ): Promise<void> => this.settingsApiService
    .updateAPIConfig(apiId as EExternalAPI, config)
    .then(() => this.toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert.'));
}
